<template>
  <li
    class="team-member"
    data-test-id="team-member"
  >
    <user-avatar
      class="team-member__avatar"
      :user="user"
      size="full"
    />
    <div class="team-member__info">
      <p
        class="team-member__name link"
        data-test-id="team-member-name"
        aria-haspopup="true"
        @click="openUserProfileTooltip"
      >
        {{ user.username }}
      </p>
      <p
        class="team-member__title"
        data-test-id="team-member-title"
      >{{ memberTitle }}</p>
      <p
        v-if="user.shortBio"
        class="team-member__description"
        data-test-id="team-member-description"
      >
        {{ user.shortBio }}
      </p>
    </div>
  </li>
</template>

<script>
import UserAvatar from '@/components/User/UserAvatar.vue';
import openUserProfileTooltipMixin from '@/mixins/open-user-profile-tooltip-mixin';

export default {
  name: 'TeamMember',
  components: {
    UserAvatar,
  },
  mixins: [openUserProfileTooltipMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showTooltip: true,
    };
  },
  computed: {
    memberTitle() {
      return this.user.roleId === 2 ? 'Patient Leader' : 'Member';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_team-member';
</style>
